import { render, staticRenderFns } from "./CrmBroadcasts.vue?vue&type=template&id=374e9f84&scoped=true"
import script from "./CrmBroadcasts.vue?vue&type=script&lang=js"
export * from "./CrmBroadcasts.vue?vue&type=script&lang=js"
import style0 from "./CrmBroadcasts.vue?vue&type=style&index=0&id=374e9f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e9f84",
  null
  
)

export default component.exports